angular.module('modals', ['toastr'])
    .service("modals", function ($uibModal, $sce, toastr) {
        this.confirmDelete = (itemName, promiseFn) => {
            let data = {
                header: "Potwierdź operację",
                msg: $sce.trustAsHtml("Czy chcesz usunąć <b>" + itemName + "</b>?"),
                fa: true
            }
            return this.open('/modals/confirm.html', 'modalsConfirmCtrl', data, {size: 'sm', windowClass: "confirmation"})
                .then(() => {
                    return promiseFn()
                        .then(() => toastr.success("Usunięto " + itemName))
                        .catch(() => toastr.error("Nie można wykonać operacji dla: " + itemName))
                })
        }
        this.confirm = (content, promiseFn) => {
            let data = {
                header: "Potwierdź operację",
                msg: $sce.trustAsHtml(content)
            }
            return this.open('/modals/confirm.html', 'modalsConfirmCtrl', data, {size: 'sm', windowClass: 'confirmation'})
                .then(promiseFn)
                .then(() => toastr.success("Wykonano poprawnie"))
        }

        this.open = (template, controller, data, options, ctrlAs) => {
            let _setOpts = opts => {
                let _opts = {}
                opts = opts || {}
                _opts.backdrop = (angular.isDefined(opts.backdrop)) ? opts.backdrop : 'static'
                _opts.size = (angular.isDefined(opts.size) && ((opts.size === 'sm') || (opts.size === 'lg') || (opts.size === 'md'))) ? opts.size : 'sm'
                _opts.animation = (angular.isDefined(opts.animation)) ? !!opts.animation : false
                _opts.windowClass = (angular.isDefined(opts.windowClass)) ? opts.windowClass : "dialogs-default" // additional CSS class(es) to be added to a modal window
                return _opts
            }

            let opts = _setOpts(options)

            return $uibModal.open({
                templateUrl: template,
                controller: controller,
                controllerAs: ctrlAs,
                backdrop: opts.bd,
                size: opts.size,
                animation: opts.animation,
                windowClass: opts.windowClass,
                resolve: {
                    data: () => data
                }
            }).result
        }
    })
    .controller('modalsConfirmCtrl', function ($scope, $uibModalInstance, $translate, data) {
        $scope.header = (angular.isDefined(data.header)) ? data.header : $translate.instant('DIALOGS_CONFIRMATION')
        $scope.msg = (angular.isDefined(data.msg)) ? data.msg : $translate.instant('DIALOGS_CONFIRMATION_MSG')
        $scope.icon = 'fa fa-check'

        $scope.no = () => $uibModalInstance.dismiss('no')
        $scope.yes = () => $uibModalInstance.close('yes')
    })
    .run(function ($templateCache, $interpolate) {
        // get interpolation symbol (possible that someone may have changed it in their application instead of using '{{}}')
        let startSym = $interpolate.startSymbol()
        let endSym = $interpolate.endSymbol()

        $templateCache.put('/modals/error.html', '<div class="modal-header dialog-header-error"><button type="button" class="close" ng-click="close()">&times;</button><h4 class="modal-title text-danger"><span class="' + startSym + 'icon' + endSym + '"></span> <span ng-bind-html="header"></span></h4></div><div class="modal-body text-danger" ng-bind-html="msg"></div><div class="modal-footer"><button type="button" class="btn btn-default" ng-click="close()">' + startSym + '"DIALOGS_CLOSE" | translate' + endSym + '</button></div>')
        $templateCache.put('/modals/wait.html', '<div class="modal-header dialog-header-wait"><h4 class="modal-title"><span class="' + startSym + 'icon' + endSym + '"></span> ' + startSym + 'header' + endSym + '</h4></div><div class="modal-body"><p ng-bind-html="msg"></p><div class="progress progress-striped active"><div class="progress-bar progress-bar-info" ng-style="getProgress()"></div><span class="sr-only">' + startSym + 'progress' + endSym + '' + startSym + '"DIALOGS_PERCENT_COMPLETE" | translate' + endSym + '</span></div></div>')
        $templateCache.put('/modals/notify.html', '<div class="modal-header dialog-header-notify"><button type="button" class="close" ng-click="close()" class="pull-right">&times;</button><h4 class="modal-title text-info"><span class="' + startSym + 'icon' + endSym + '"></span> ' + startSym + 'header' + endSym + '</h4></div><div class="modal-body text-info" ng-bind-html="msg"></div><div class="modal-footer"><button type="button" class="btn btn-primary" ng-click="close()">' + startSym + '"DIALOGS_OK" | translate' + endSym + '</button></div>')
        $templateCache.put('/modals/confirm.html', '<div class="modal-header dialog-header-confirm"><button type="button" class="close" ng-click="no()">&times;</button><h4 class="modal-title"><span class="' + startSym + 'icon' + endSym + '"></span> ' + startSym + 'header' + endSym + '</h4></div><div class="modal-body" ng-bind-html="msg"></div><div class="modal-footer"><button type="button" class="btn btn-default" ng-click="yes()">' + startSym + '"DIALOGS_YES" | translate' + endSym + '</button><button type="button" class="btn btn-primary" ng-click="no()">' + startSym + '"DIALOGS_NO" | translate' + endSym + '</button></div>')
    })
